import { array } from "prop-types";
import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { TWILIO_PHONE } from "../config/apiEndPoint";
import { GET, POST, PUT, DEL } from "config/api.config";

export const getTwilioPhoneList = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${TWILIO_PHONE.GET_TWILIO_PHONE_LIST}/${data?._Id}`
      : `${TWILIO_PHONE.GET_TWILIO_PHONE_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addTwilioPhone = async (data = array()) => {
  try {
    const response = await POST(TWILIO_PHONE.ADD_TWILIO_PHONE, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateTwilioPhone = async (id, data = array()) => {
  try {
    const url = `${TWILIO_PHONE.ADD_TWILIO_PHONE}/${id}`;
    const response = await PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getTwilioPhoneDataById = async (data = array()) => {
  try {
    const url = data?.Id
      ? `${TWILIO_PHONE.GET_TWILIO_PHONE_LIST}/${data?.Id}`
      : `${TWILIO_PHONE.GET_TWILIO_PHONE_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchTwilioPhoneTableAndFilterSchema = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${TWILIO_PHONE.GET_TWILIO_PHONE_SCHEMA}/${data?._Id}`
      : `${TWILIO_PHONE.GET_TWILIO_PHONE_SCHEMA}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitTwilioPhoneFilterData = async (data = array()) => {
  try {
    const response = await POST(TWILIO_PHONE.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** DELETE `master/twilio-phone-number/{phoneId}` */
export const deleteTwilioPhone = async (phoneId = "") => {
  const raw = String(phoneId ?? "").trim();
  if (!raw) return null;
  try {
    const response = await DEL(TWILIO_PHONE.BY_ID(raw));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
